import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const CTAChemical = () => {
  const whatsappMessage =
    'Hola, me interesa la propuesta Chemical x TNO Network (TNO Business, Franquicias en Venezuela, 4 artículos Digest al mes siempre, plan $400/mes).';

  return (
    <Box marginBottom={2}>
      <Typography
        component="h2"
        sx={{ fontWeight: 700 }}
        variant="h4"
        gutterBottom
        align="center"
      >
        Hablemos de Chemical en TNO
      </Typography>
      <Typography variant="body1" align="center" color="textSecondary" sx={{ mb: 3, maxWidth: 680, mx: 'auto' }}>
        Estrategia disruptiva para atraer emprendedores: mentoría en vivo, SEO con WhatsApp y Reels con tono
        profesional. En TNO combinamos mística y tecnología para que su marca de distribución brille.
      </Typography>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="center"
        gap={2}
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
            window.open(url, '_blank');
          }}
        >
          Contactar · Chemical x TNO
        </Button>
        <Button
          href="https://www.tnonetwork.com"
          variant="outlined"
          color="primary"
          size="large"
          target="_blank"
          rel="noopener noreferrer"
        >
          Conocer TNO Network
        </Button>
      </Box>
    </Box>
  );
};

export default CTAChemical;
